import * as swcHelpers from '@swc/helpers';
import { customTransitionLensConfig, defaultTransitionLensConfig } from '@grandvisionhq/fun-products';
import { convertCentsToDecimalString, placeholderImage, isString } from '@grandvisionhq/utils';
import { getPrice } from './get-price.js';

const mapVirtualMirrorVariants = (variants, activeSku, locale, isVtoTransitionsEnabled = false)=>{
    const prices = variants.filter((variant)=>variant.vtoEnabled
    ).map((variant)=>{
        const { sku  } = variant;
        const price = getPrice(variant.prices);
        if (!price || !price.originalPrice) {
            return {
                upc: sku,
                current: {
                    text: undefined,
                    value: undefined
                }
            };
        }
        const originalPrice = convertCentsToDecimalString(price.originalPrice);
        const discountedPrice = price.discountedPrice ? convertCentsToDecimalString(price.discountedPrice) : undefined;
        return swcHelpers.objectSpread({
            upc: sku,
            current: {
                text: `${originalPrice}`,
                value: Number(originalPrice)
            }
        }, discountedPrice ? {
            previous: {
                text: `${originalPrice}`,
                value: Number(originalPrice)
            },
            current: {
                text: `${discountedPrice}`,
                value: Number(discountedPrice)
            }
        } : undefined, {
            currency: price.currency
        });
    }).reduce((acc, curr)=>curr.upc === activeSku ? [
            curr,
            ...acc
        ] : [
            ...acc,
            curr
        ]
    , []);
    const products = variants.filter((variant)=>variant.vtoEnabled
    ).map((variant)=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        const { sku , name , media , attributes  } = variant;
        const productCode = (ref = attributes === null || attributes === void 0 ? void 0 : attributes.find((item)=>item.name === 'brandModelCode'
        )) === null || ref === void 0 ? void 0 : ref.value;
        const productColorCode = (ref1 = attributes === null || attributes === void 0 ? void 0 : attributes.find((item)=>item.name === 'brandModelColorCode'
        )) === null || ref1 === void 0 ? void 0 : ref1.value;
        const brandName = (ref2 = attributes === null || attributes === void 0 ? void 0 : attributes.find((item)=>item.name === 'brand'
        )) === null || ref2 === void 0 ? void 0 : ref2.value;
        const variantImages = (media === null || media === void 0 ? void 0 : media.images) && (media === null || media === void 0 ? void 0 : media.images.length) > 0 && ((ref3 = media.images[0]) === null || ref3 === void 0 ? void 0 : ref3.url) ? media.images[0].url : [
            placeholderImage
        ];
        const lensColor = (ref4 = attributes === null || attributes === void 0 ? void 0 : attributes.find((item)=>item.name === 'lensColor'
        )) === null || ref4 === void 0 ? void 0 : ref4.value[locale];
        const frameColorAttribute = (ref5 = attributes === null || attributes === void 0 ? void 0 : attributes.find((item)=>item.name === 'frameColor'
        )) === null || ref5 === void 0 ? void 0 : ref5.value;
        let frameColorLabel = Array.isArray(frameColorAttribute) ? frameColorAttribute[0][locale] : frameColorAttribute === null || frameColorAttribute === void 0 ? void 0 : frameColorAttribute[locale];
        if (!isString(frameColorLabel)) {
            frameColorLabel = '';
        }
        const isTransitionEnabled = isVtoTransitionsEnabled && variant.isOfferedWithPrescriptions === true;
        const transitionLens = isTransitionEnabled ? customTransitionLensConfig : defaultTransitionLensConfig;
        return {
            upc: sku,
            code: productCode,
            name,
            colorCode: productColorCode !== null && productColorCode !== void 0 ? productColorCode : '',
            thumbnailUrl: variantImages,
            brand: {
                name: brandName,
                logoUrl: ''
            },
            lensColorLabel: isString(lensColor) ? lensColor : '',
            frameColorLabel,
            styleName: '',
            isCustom: false,
            size: '58 14',
            isTransition: isTransitionEnabled,
            transitionLens
        };
    }).reduce((acc, curr)=>curr.upc === activeSku ? [
            curr,
            ...acc
        ] : [
            ...acc,
            curr
        ]
    , []);
    return {
        prices,
        products
    };
};

export { mapVirtualMirrorVariants };
//# sourceMappingURL=map-virtual-mirror-variants.js.map
